<template>
  <div class="image-viewer-container">
    <el-image
      :src="fullImageUrl"
      :alt="alt"
      :fit="fit"
      :preview="preview"
      :preview-src-list="effectivePreviewSrcList"
      :preview-teleported="previewTeleported"
      :z-index="zIndex"
	  style="width: 100%; height: 100px;"
    >
      <template v-if="placeholder" #placeholder>
        <div class="image-placeholder">
          <i class="el-icon-picture-outline"></i>
        </div>
      </template>
      <template v-if="error" #error>
        <div class="image-error">
          <i class="el-icon-picture-outline"></i>
        </div>
      </template>
    </el-image>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: 'cover'
    },
    preview: {
      type: Boolean,
      default: true
    },
    previewSrcList: {
      type: Array,
      default: () => []
    },
    previewTeleported: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    placeholder: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    imageDomain() {
      return this.$store.getters.getImg
    },
    fullImageUrl() {
      if (!this.src) return ''
      return this.src.startsWith('http') ? this.src : `${this.imageDomain}${this.src}`
    },
    effectivePreviewSrcList() {
		if(!this.preview){
			return
		}
      if (this.previewSrcList.length === 0) {
        return [this.fullImageUrl]
      }
      return this.previewSrcList.map(url => {
        return url.startsWith('http') ? url : `${this.imageDomain}${url}`
      })
    }
  }
}
</script>

<style scoped>
.image-viewer-container {
  display: inline-block;
}

.image-placeholder,
.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #c0c4cc;
  font-size: 24px;
}
</style>
